// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"246ebd36","138":"a967830e","439":"9ab900cb","557":"cfd998e8"}[chunkId] + ".chunk.js";
};